(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsGenericToggle', rmsGenericToggle);

    function rmsGenericToggle(lodash) {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                options: '=?',
                data: '=',
            },
            controller: rmsGenericToggleCtrl,
            controllerAs: "vm",
            templateUrl: 'common/app/components/generic-toggle',
            link: function (scope, elem, attr, ctrl) {
                var vm = scope.vm;

                vm.toggleSelector = toggleSelector;
                vm.setModelValue = setModelValue;

                // ctrl.$formatters.push(function (modelValue) {
                //     return modelValue;
                // });]

                ctrl.$render = function () {
                    if (ctrl.$viewValue) {
                        vm.model = new vm.Model(ctrl.$viewValue['choice']);
                    }
                };

                scope.$watch('vm.model', function () {
                    setModelValue(vm.model);
                }, true);

                function setModelValue(value) {
                    return ctrl.$setViewValue(value);
                }

                function toggleSelector(value) {
                    return vm.model.choice === value ? vm.setValue('nil') : vm.setValue(value)
                }
            }
        };
    }

    function rmsGenericToggleCtrl($scope, lodash, $timeout) {
        var vm = this;
        this.$onInit = function() {
            vm.model = null;
            vm.states = $scope.options;
            vm.Model = Model;

            vm.setValue = setValue;
        }

        function setValue(value) {
            return $timeout(function () {
                vm.model = new Model(value);
                return vm.setModelValue(vm.model);
            })
        }

        function Model(choice) {
            this.value = $scope.data.value;
            this.choice = choice;
            this.required = $scope.data.required;
        }
    }
})();